/**
* Project janux-vuejs-seed
* Created by hielo on 2018-09-14
*/

<template lang="pug">
	md-dialog-alert(:md-active.sync='infoDialogShow', :md-content='infoDialogText')
</template>

<script>
import state from 'CommonApp/store/state'
import store from 'CommonApp/store'

export default {
	name: 'info-dialog',
	computed: {
		infoDialogShow: {
			get: () => {
				return state.dialog.info.show
			},
			set: () => {
				store.dispatch('infoDialog', '')
			}
		},
		infoDialogText () {
			return state.dialog.info.text
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/common/components/dialogs/info.vue